import React from "react";
import { observer, inject } from "mobx-react";

@inject("store")
@observer

export default class CustomerOrderCopyDocument extends React.Component {


    constructor(props) {
        super(props);
        this.update = this.update.bind(this);
        this.state = { content: null, orderGuid: null }


    }


    componentDidMount() {
        this.update();
    }

    componentDidUpdate(prevProps, prevState) {
        this.update();
    }


    update() {
        const match = this.props.match;
        const orderGuid = match.params.orderguid;
        if (this.state.orderGuid !== orderGuid) {
            this.setState({ orderGuid : orderGuid});
            this.props.store.reports.getOrderDocumentUrl("OrderCopy", orderGuid).then(result => {
                this.setState({ content: result.content});
            });
        }
    }


    render() {
        return (
            <div 
                dangerouslySetInnerHTML={{ __html: this.state.content }}></div >
        );
    }
}